<ion-spinner></ion-spinner>
<ion-label>{{text}}</ion-label>
